export default {
  computed: {
    answers() {
      let answers = this.flashcard.answers || [];
      if (this.flashcard?.randomizedSortOrder) {
        // generate pseudo-random number based on flashcard id
        // bit mask that number to the first 8 bits
        // giving us a possible 256 values 0 - 255
        const pseudoRandom = (id) => {
          var t = id += 0x6D2B79F5;
          t = Math.imul(t ^ t >>> 15, t | 1);
          t ^= t + Math.imul(t ^ t >>> 7, t | 61);
          return ((t ^ t >>> 14) >>> 0) / 4294967296;
        };
        return [...answers].sort((a, b) => pseudoRandom(a.id) - pseudoRandom(b.id));
      } else {
        return [...answers].sort((a, b) => a.sortOrder - b.sortOrder);
      }
    },
  },
};
